export default __webpack_public_path__ + "static/media/bunda.95368617.png";